import React, { FC, useState } from 'react';
import {Icon} from '../components/Icon';
import Modal from "@mui/material/Modal";

interface PersonalInfoPopupProps {
  open: boolean;
  onClose: () => void;
}

export const PersonalInfoPopup: FC<PersonalInfoPopupProps> = ({
                                                                onClose,
                                                                open,
                                                              }) => {

  return (
      <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className={`flex justify-center items-center`}
      >
        <div className={`bg-white max-w-md w-full py-6 px-6 flex flex-col gap-y-5 md:h-auto h-full overflow-y-auto`}>
          <div className={`text-16 font-bold flex justify-between items-center`}>개인정보 수집 및 이용 동의 <Icon.X onClick={onClose} className={`cursor-pointer`} /></div>
          <p className={`text-12`}>
            (주)웍스아웃은 아래와 같이 개인정보를 수집 및 이용하며 개인정보 보호를 진행하고 있습니다.<br/>
            내용 확인 후 동의해 주시기 바랍니다.
          </p>
          <ul className={`text-12 list-marker shadow-lg`}>
            <li className={`grid grid-cols-12 gap-x-4`}>
              <span className={`bg-gray-100 col-span-4 flex items-center justify-center`}>목적</span>
              <ul className={`col-span-8 py-2 pr-3 list-marker-in`}>
                <li>홈페이지 회원가입 및 관리</li>
                <li>민원 사무 처리</li>
                <li>재화 또는 서비스 제공</li>
                <li>마케팅 및 광고에의 활용</li>
                <li>판매자와 구매자의 거래의 원활한 진행, 본인 의사의 확인</li>
              </ul>
            </li>
            <li className={`grid grid-cols-12 gap-x-4 border-t border-b border-gray-100`}>
              <span className={`bg-gray-100 col-span-4 flex items-center justify-center`}>항목</span>
              <ul className={`col-span-8 py-2 pr-3 list-marker-in`}>
                <li>회원 가입 시: 이름, 생년월일, 성별, 이메일(ID), 비밀번호, 휴대전화번호 , 이메일 회원 가입 시 선택 사항: SMS, 이메일 등의 마케팅 수신 동의 여부</li>
                <li>비회원 이용 시: 이름, 휴대폰 번호,전화번호, 이메일 주소,배송지 주소, 신용카드 정보, 은행 계좌 정보, 접속 IP 정보, 쿠키, 서비스 이용 기록, 접속 로그</li>
                <li>서비스 신청 시 : 주소,이름,연락처,취소 및 환불계좌정보, 결제 정보 서비스 이용 과정이나 사업 처리 과정에서 서비스이용기록, 접속로그, 쿠키, 접속 IP, 결제 기록,교환,반품,수선,상담 이력</li>
                <li>타 업체 입점 신청 시: 담당자 이름,전화번호,이메일,주소,사업자명,사업자주소,사업자번호,대표자명</li>
              </ul>
            </li>
            <li className={`grid grid-cols-12 gap-x-4`}>
              <span className={`bg-gray-100 col-span-4 flex items-center justify-center`}>보유 및 이용기간</span>
              <ul className={`col-span-8 py-2 pr-3 list-marker-in`}>
                <li>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우 보유기간의 종료일로부터 5일 이내</li>
                <li>개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내</li>
              </ul>
            </li>
          </ul>
          <p className={`text-12`}>※ 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부 시 회원가입 및 서비스 이용이 제한됩니다.</p>
        </div>
      </Modal>
  );
};
